import metaApiClient from './meta-client';

export interface ChatfoodSyncRequest {
    token: string;
    user_ids: number[];
}

export interface ChatfoodSyncResult {
    matched: number;
    skipped: number;
    pages_updated: number;
    vars_saved: number;
    errors: { page_id: string; error: string }[];
}

export async function syncChatfoodPages(data: ChatfoodSyncRequest): Promise<ChatfoodSyncResult> {
    const response = await metaApiClient.post<ChatfoodSyncResult>('/admin/chatfood/sync', data);
    return response.data;
}
